module.exports = __webpack_public_path__ + "static/media/pollution.384d1830.jpg";